import { useEffect, useState } from "react";
import { API_BASE_URL } from "../config";

export interface PaymentSettings {
  instapayLink: string;
  walletNumber: string;
  walletName: string;
  whatsappNumber: string;
}

export function usePaymentSettings(): PaymentSettings | null {
  const [settings, setSettings] = useState<PaymentSettings | null>(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/payment-settings`);
        const data = await response.json();
        setSettings(data.paymentSettings || null);
      } catch (error) {
        console.error("Error fetching payment settings:", error);
      }
    };

    fetchSettings();
  }, []);

  return settings;
}
